import React, { useEffect, useState } from "react";
import "../common/Util.css";
import TruckProgressBar from "./truck-progress-bar";
import LoaderModal from "../common/loader";
import { useNavigate, useLocation } from "react-router-dom";
import { Toast, ToastContainer } from "react-bootstrap";
import { MoveLeft } from "lucide-react";
import CommonDropdown from "../common/common_dropDown";
import { getStopLocationsApi, getDeliveryLocationsApi, getTripHistoryRouteApi, getTripPlanRouteApi, getStopsListApi, fetchActualRouteApi } from "./live-view-api";
import polyline from "@mapbox/polyline";
import stopPinImg from "../../assets/png/planned-pin.png";
import { MapContainer, TileLayer, Marker, Popup, Polyline } from "react-leaflet";
import L from "leaflet";
import tripRouteIcon from "../../assets/svg/trip_route_ic1.svg";
import receiverIcon from "../../assets/svg/receiver_green_ic.svg";
import locationIcon from "../../assets/svg/location_pin_red.svg";
import stopIcon from "../../assets/svg/stops-inactive.svg";
import minutesIC from "../../assets/svg/minutes_ic.svg";
import completedPinImg from "../../assets/png/delivery-pin.png";
import Sidebar from "../common/Sidebar";
import { useGlobal } from "../../GlobalContext.js";
import MarkerClusterGroup from "react-leaflet-markercluster";
import ProfileImageModal from "../common/ProfileImageModal";

export const TripLiveTrack = () => {
  const { rolePermissionList, userType } = useGlobal();

  function checkPermission(menuName, permission) {
    return rolePermissionList.findIndex((element) => element["name"] === menuName && element["menu_permission"] === true && element[permission] === true) > -1 ? true : false;
  }

  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const location = useLocation();

  const [isLoading, setIsLoading] = useState(false);
  const [trip, setTrip] = useState({});
  const [stopsFilter, setStopsFilter] = useState("All");
  const [query, setQuery] = useState("");
  const [tripOption, setTripOption] = useState(null);
  const [stopPinLocation, setStopPinLocation] = useState([]);
  const [deliveryPinLocation, setDeliveryPinLocation] = useState([]);
  const [polylinePlanned, setPolylinePlanned] = useState([]);
  const [polylineHistory, setPolylineHistory] = useState([]);
  const [stopList, setStopList] = useState([]);
  const [tripId, setTripId] = useState(null);
  const [toast, setToast] = useState({
    show: false,
    message: "",
    variant: "success",
  });
  const [showProfilePopup, setShowProfilePopup] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState("");
  const { id, tripCode } = location.state || {};

  useEffect(() => {
    if (id != null) {
      setTripId(id);
      setTripOption({ value: id, label: tripCode });
      getStopLocations(id);
      getDeliveryLocations(id);
      getStopsList(id);
      getTripPlanRoute(id);
    }
  }, [id]);

  useEffect(() => {
    if (tripId != null) {
      getStopsList(tripId);
    }
  }, [stopsFilter, query]);
  // sample rich trip data to mimic screenshot structure
  /*  useEffect(() => {
    setIsLoading(true);
    const demo = {
      trip_id: "#SD3948583",
      vehicle_no: "TN 23 UXUI 6758",
      driver: "David Martinez",
      driver_mobile: "+919876543210",
      status: "In Transit",
      started_on: "08:23 PM",
      stops_total: 34,
      completed: 16,
      pending: 18,
      distance_km: 123,
      timeline: {
        start: "Jan 19",
        end: "Jan 20",
        progressPercent: 42,
      },
      stops: Array.from({ length: 8 }).map((_, i) => ({
        id: i + 1,
        title: `Anna salai main road, Chennai - 6000${i}`,
        eta: `${8 + i}:00 am`,
        status: i < 4 ? "Completed" : i === 4 ? "Current" : "Pending",
        distanceFromVehicle: `${(i + 1) * 5} km`,
      })),
    };

    const t = setTimeout(() => {
      setTrip(demo);
      setIsLoading(false);
    }, 200);

    return () => clearTimeout(t);
  }, []); */

  if (!trip && !isLoading) return null;

  const filteredStops = (trip?.stops || [])
    .filter((s) => {
      if (stopsFilter === "all") return true;
      if (stopsFilter === "true") return s.status === "Completed";
      if (stopsFilter === "false") return s.status === "Pending" || s.status === "Current";
      return true;
    })
    .filter((s) => s.title.toLowerCase().includes(query.toLowerCase()));

  const getStopLocations = async (tripId) => {
    try {
      const response = await getStopLocationsApi(tripId);

      if (response.data.success === true) {
        setTrip(response.data.trip ?? {});
        const tripDetails = response.data.trip ?? {};

        if (tripDetails["stopadderss"].length > 0) {
          setStopPinLocation(tripDetails["stopadderss"].filter((marker) => marker["latitude"] != null && marker["longitude"] != null && marker["latitude"] !== "" && marker["longitude"] !== ""));
          /* tripDetails["stopadderss"].forEach((marker, index2) => {
            //const [lat, lng] = decoded[index2];
            if (
              marker["latitude"] == null ||
              marker["longitude"] == null ||
              marker["latitude"] === "" ||
              marker["longitude"] === ""
            ) {
            } else {
             
            }
          }); */
        }
      } else {
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getDeliveryLocations = async (tripId) => {
    try {
      const response = await getDeliveryLocationsApi(tripId);

      if (response.data.success === true) {
        setTrip(response.data.trip ?? {});
        const tripDetails = response.data.data ?? [];

        if (tripDetails.length > 0) {
          setDeliveryPinLocation(tripDetails.filter((marker) => marker["status"] === "Delivered" && marker["latitude"] != null && marker["longitude"] != null && marker["latitude"] !== "" && marker["longitude"] !== ""));
        }
      } else {
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getStopsList = async (tripId) => {
    try {
      const response = await getStopsListApi(tripId, stopsFilter, query);

      if (response.data.success === true) {
        setStopList(response.data.stops ?? {});
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getTripPlanRoute = async (tripId) => {
    try {
      const response = await getTripPlanRouteApi(tripId);

      if (response.data.success === true) {
        const routeList = response.data.response ?? [];
        console.log("routeList", routeList.length);
        if (routeList.length > 0) {
          createPolylines(routeList, "customer");
        }
      } else {
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getTripHistoryRoute = async (tripId, retry = false) => {
    try {
      setIsLoading(true);
      const response = await getTripHistoryRouteApi(tripId);

      if (response.data.success === true) {
        const routeList = response.data.response ?? [];
        console.log("routeList", routeList.length);

        if (routeList.length > 0) {
          createPolylines(routeList, "history");
          console.log("routeList after ", routeList.length);
        } else {
          // Prevent infinite recursion
          if (retry) {
            setToast({
              show: true,
              message: "Actual route not found",
              variant: "danger",
            });
            return response.data;
          }

          const actualRouteResponse = await fetchActualRouteApi(tripId);
          console.log("actualRouteResponse", actualRouteResponse);

          if (actualRouteResponse.data.success === true) {
            console.log("Actual route saved, re-fetching history route");
            await getTripHistoryRoute(tripId, true);
          } else {
            setToast({
              show: true,
              message: "Actual route not found",
              variant: "danger",
            });
          }
        }
      }

      return response.data;
    } catch (err) {
      console.error("Error fetching route:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const createPolylines = (routeList, type) => {
    const newPolylines = [];
    const newDeliveryPins = [];

    routeList.forEach((item, index) => {
      console.log(`index..... ${index}`);
      console.log("POINTS VALUE:", item.points);

      if (item.points && typeof item.points === "string" && item.points.length > 0) {
        try {
          const decoded = polyline.decode(item.points);
          console.log("DECODED:", decoded);

          if (decoded && decoded.length > 0) {
            if (type === "history" && item.plot === true) {
              newDeliveryPins.push({
                latitude: decoded[0][0],
                longitude: decoded[0][1],
              });
            }

            newPolylines.push({
              id: `poly_${type}_${index}`,
              positionList: decoded,
            });
          }
        } catch (parseError) {
          console.log(`Invalid polyline at index ${index}`, item.points, parseError);
        }
      } else {
        console.log(`Skipping index ${index}: points is missing or invalid`, item.points);
      }
    });

    // Store polylines in state
    if (type === "history") {
      setPolylineHistory(newPolylines);

      if (newDeliveryPins.length > 0) {
        setDeliveryPinLocation(newDeliveryPins);
      }
    } else {
      setPolylinePlanned(newPolylines);
    }
  };

  const createCustomMarker = (text) =>
    L.divIcon({
      className: "custom-icon",
      html: `
            <div style="position: relative; display: inline-block;">
              <!-- Your image from assets -->
              <img src="${stopPinImg}" style="width:40px;height:40px;" />
              
              <!-- Text overlay -->
              <span style="
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                color: white;
                font-size: 14px;
                font-weight: bold;
              ">
                ${text}
              </span>
            </div>
          `,
      iconSize: [40, 40], // size of whole div
      iconAnchor: [20, 40], // bottom center
      popupAnchor: [0, -40],
    });
  const createCompletedPinMarker = (text) =>
    L.divIcon({
      className: "custom-icon",
      html: `
            <div style="position: relative; display: inline-block;">
              <!-- Your image from assets -->
              <img src="${completedPinImg}" />
              
              <!-- Text overlay -->
              <span style="
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                color: white;
                font-size: 14px;
                font-weight: bold;
              ">
                ${text}
              </span>
            </div>
          `,
      iconSize: [40, 40], // size of whole div
      iconAnchor: [20, 40], // bottom center
      popupAnchor: [0, -40],
    });
  return (
    <div className="d-flex ">
      <Sidebar currentfile="Live View" />
      <div className="flex-grow-1  pm-background " style={{ width: "calc(100vw - 80px)", height: "calc(100vh - 56px)" }}>
        <LoaderModal show={isLoading} />

        <div className="bg-half-white p-3 rounded-4" style={{ width: "100%" }}>
          {/* Top bar: Trip selector + summary */}
          <div className="d-flex align-items-center justify-content-between p-2" style={{ gap: 12 }}>
            <div className="col-12 col-md-6 col-lg-4 d-flex align-items-center gap-3 p-2" style={{ borderRadius: "16px", background: "#FFFFFF" }}>
              <button
                className="btn btn-light rounded-circle"
                onClick={() => {
                  navigate(-1);
                }}
                style={{
                  width: "36px",
                  height: "36px",
                  borderRadius: "100px",
                  border: "0.6px solid #EBEBEB",
                  background: "#FFFFFF",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <MoveLeft className="cursor-pointer" />
              </button>
              <div className="d-flex flex-column align-items-start" style={{ flex: 1 }}>
                <div className="trip-drop-down">Trip ID</div>
                <div className="w-100 d-flex align-items-center gap-2 mt-2">
                  <CommonDropdown
                    apiUrl={`${apiUrl}trips/autosuggestion?module=tripcost&fromDate=&toDate=`}
                    placeholder="Select"
                    value={tripOption}
                    onSelect={(item) => {
                      setStopPinLocation([]);
                      setDeliveryPinLocation([]);
                      setPolylinePlanned([]);
                      setPolylineHistory([]);
                      setTripOption(item);
                      getStopLocations(item.value);
                      getDeliveryLocations(item.value);
                      getStopsList(item.value);
                      getTripPlanRoute(item.value);
                      setTripId(item.value);
                    }}
                  />
                </div>
              </div>
              <div
                className="badge px-3 py-2"
                style={{
                  background: "#EEF8FF",
                  color: "#0C62B8",

                  borderRadius: 8,
                }}
              >
                {trip?.status}
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-8  d-flex align-items-center gap-2 p-2" style={{ borderRadius: "16px", background: "#FFFFFF" }}>
              <div className="d-flex w-100 gap-2">
                <div className="col-6 d-flex gap-2">
                  <div className="col-4 p-2 rounded-3 text-start" style={{ background: "#F0F5FF" }}>
                    <div className="trip-count-title">STOPS</div>
                    <div className="trip-count-value mt-2">{trip?.total_stops}</div>
                  </div>
                  <div className="col-4 p-2 rounded-3 text-start" style={{ background: "#D2FFE4" }}>
                    <div className="trip-count-title">COMPLETED</div>
                    <div className="trip-count-value mt-2">{trip?.completed_stops}</div>
                  </div>
                  <div className="col-4 p-2 rounded-3 text-start" style={{ background: "#FFF9E3" }}>
                    <div className="trip-count-title">PENDING</div>
                    <div className="trip-count-value mt-2">{trip?.pending_stops}</div>
                  </div>
                </div>
                <div className="col-6">
                  <div className="w-100 d-flex align-items-center justify-content-between  p-2 mx-3" style={{ borderRadius: "16px", background: "#F8F8F8" }}>
                    <div className="d-flex align-items-center gap-2">
                      {/* <div
                    style={{
                      width: 44,
                      height: 44,
                      borderRadius: 44,
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src={`https://i.pravatar.cc/44?u=${trip?.driver}`}
                      alt="driver"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </div> */}
                      <div
                        style={{
                          width: 44,
                          height: 44,
                          borderRadius: 44,
                          background: "#F4F4F6",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {trip.driverDetails?.length > 0 ? trip?.driverDetails[0]?.driver_name?.charAt(0) ?? "D" : "D"}
                      </div>
                      <div className="d-flex flex-column align-items-start ms-1">
                        <div className="fw-700">{trip.driverDetails?.length > 0 ? trip.driverDetails[0]?.driver_name ?? "---" : "---"}</div>
                        <div className="fs-12 text-muted">{trip.license_plate ?? ""}</div>
                      </div>
                    </div>

                    <div className="d-flex gap-2" style={{ width: "86px" }}>
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          /* navigate("/trips/view", { state: { id: trip.id } }); */
                        }}
                        className="d-flex align-items-center justify-content-center"
                        style={{
                          width: "36px",
                          height: "36px",
                          borderRadius: "100px",
                          background: "#F6F6F6",
                        }}
                      >
                        <img src={tripRouteIcon} alt="Trip Route Icon" />
                      </div>

                      {trip.driverDetails?.length > 0 && (
                        <div
                          onClick={() => (window.location.href = `tel:${trip.driverDetails[0]?.mobile_number ?? ""}`)}
                          className="d-flex align-items-center justify-content-center"
                          style={{
                            width: "36px",
                            height: "36px",
                            borderRadius: "100px",
                            background: "#F6F6F6",
                          }}
                        >
                          <img src={receiverIcon} alt="Receiver Icon" />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Timeline slider (simple visual) */}
          <div className="bg-white rounded-4 p-2">
            <div className="mb-3 d-flex align-items-center justify-content-between">
              <div className="col-5">
                <div className="d-flex flex-column align-items-start">
                  <div className="fs-15 fw-700" style={{ color: "#2F2F2F" }}>
                    {trip.license_plate ?? ""}
                  </div>
                  <div className="fs-13 fw-400" style={{ color: "#3F9A30" }}>
                    Running from <span>{trip.vehicle_running_time ?? "---"}</span>
                  </div>
                  <div className="mt-1 d-flex align-items-center justify-content-start">
                    {trip.vehicle_status === true && (
                      <div className="px-3 py-1 rounded-4 d-flex align-items-center justify-content-center" style={{ background: "#3F9A30" }}>
                        <span className="fs-13 fw-700 text-white">On</span>
                      </div>
                    )}
                    <span className="mx-2 px-1 py-1 rounded-4 " style={{ background: "#A7B1BB" }}></span>
                    <img src={minutesIC} alt="minutes icon" />
                    <span className="ms-1 fs-11 fw-600" style={{ color: "#95A1AD" }}>
                      {trip?.vehicle_start_time}
                    </span>
                  </div>
                </div>
              </div>
              {checkPermission("Live view", "menu_permission") && (
                <div className="col-2 d-flex align-items-center justify-content-center">
                  <button
                    className="btn btn-primary btn-sm"
                    style={{
                      fontSize: "12px",
                      fontWeight: "500",
                      background: "#0C62B8",
                      borderColor: "#0C62B8",
                    }}
                    onClick={() => getTripHistoryRoute(tripId)}
                  >
                    Actual Route
                  </button>
                </div>
              )}

              <div className="col-5 d-flex flex-column">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="fs-12 text-muted">{trip?.start_date}</div>
                  <div className="fs-12 text-muted">{trip?.end_date}</div>
                </div>
                <TruckProgressBar totalStops={trip.total_stops} currentStop={trip.total_stops - trip.pending_stops} showLabels={false} />
              </div>
            </div>

            {/* Main content: Map (left) + Stops panel (right) */}
            <div className="d-flex" style={{ gap: 8 }}>
              <div style={{ flex: 1 }}>
                <div
                  className="bg-white rounded-4"
                  style={{
                    height: "68vh",
                    position: "relative",
                    overflow: "hidden",
                  }}
                >
                  {/* Map placeholder: simulate route with SVG and markers */}
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      borderRadius: 8,
                      background: "linear-gradient(180deg,#f8fafc,#ffffff)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#9CA3AF",
                    }}
                  >
                    <MapContainer center={[30, 0]} zoom={2} style={{ height: "100%", width: "100%" }}>
                      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution='&copy; <a href="href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>' />

                      {/* Markers for stops from stopList */}
                      {/*  {stopList
                        .filter((stop) => stop.latitude && stop.longitude && stop.latitude !== "" && stop.longitude !== "")
                        .map((stop, index) => {
                          const lat = parseFloat(stop.latitude);
                          const lng = parseFloat(stop.longitude);
                          const icon = stop.status === true ? createCompletedPinMarker(stop.seq || index + 1) : createCustomMarker(stop.seq || index + 1);

                          return (
                            <Marker key={`stop-${stop.stop_code}-${index}`} position={[lat, lng]} icon={icon}>
                              <Popup>
                                <div style={{ minWidth: "250px", padding: "10px" }}>
                                  <h6 style={{ fontWeight: "bold", marginBottom: "8px" }}>#{stop.stop_code}</h6>
                                  <p style={{ margin: "4px 0", fontSize: "13px" }}>
                                    <strong>Customer:</strong> {stop.customer || "N/A"}
                                  </p>
                                  <p style={{ margin: "4px 0", fontSize: "13px" }}>
                                    <strong>Location:</strong> {stop.location_name || "N/A"}
                                  </p>
                                  <p style={{ margin: "4px 0", fontSize: "13px" }}>
                                    <strong>Address:</strong> {stop.address || "N/A"}
                                  </p>
                                  {stop.ph_number && (
                                    <p style={{ margin: "4px 0", fontSize: "13px" }}>
                                      <strong>Phone:</strong> {stop.ph_number}
                                    </p>
                                  )}
                                  <p style={{ margin: "4px 0", fontSize: "13px" }}>
                                    <strong>Status:</strong> <span style={{ color: stop.status ? "#2C8C53" : "#FFC05D", fontWeight: "bold" }}>{stop.status ? "Completed" : "Pending"}</span>
                                  </p>
                                  {stop.planned_time && (
                                    <p style={{ margin: "4px 0", fontSize: "12px" }}>
                                      <strong>Planned:</strong> {stop.planned_time}
                                    </p>
                                  )}
                                  {stop.actual_time && (
                                    <p style={{ margin: "4px 0", fontSize: "12px" }}>
                                      <strong>Actual:</strong> {stop.actual_time}
                                    </p>
                                  )}
                                  <p style={{ margin: "4px 0", fontSize: "12px" }}>
                                    <strong>Sequence:</strong> {stop.seq || index + 1}
                                  </p>
                                </div>
                              </Popup>
                            </Marker>
                          );
                        })} */}

                      {/* Markers for stopPinLocation (from getStopLocationsApi) */}
                      <MarkerClusterGroup
                        iconCreateFunction={(cluster) => {
                          const markers = cluster.getAllChildMarkers();
                          const firstMarker = markers[0];

                          return L.divIcon({
                            html: `
        <div style="position: relative; display: inline-block;" >
          <img src="${stopPinImg}"
                object-fit:cover;" style="
            width:40px;
            height:40px;
        " />
               <span style="
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                color: white;
                font-size: 13px;
                font-weight: bold;
              ">
               ... ${markers.length}
              </span>
        </div>
      `,
                            className: "custom-cluster",
                            iconSize: L.point(50, 50),
                          });
                        }}
                      >
                        {stopPinLocation.map((coord, index) => {
                          console.log(coord);
                          return (
                            <Marker key={`Stop${index}`} position={[coord.latitude, coord.longitude]} icon={createCustomMarker(index + 1)}>
                              <Popup>{coord.stop_code ?? ""}</Popup>
                            </Marker>
                          );
                        })}
                      </MarkerClusterGroup>
                      <MarkerClusterGroup
                        iconCreateFunction={(cluster) => {
                          const markers = cluster.getAllChildMarkers();
                          const firstMarker = markers[0];

                          return L.divIcon({
                            html: `
        <div style="position: relative; display: inline-block;" >
          <img src="${completedPinImg}"
                object-fit:cover;" style="
            width:40px;
            height:40px;
        " />
               <span style="
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                color: white;
                font-size: 13px;
                font-weight: bold;
              ">
               ... ${markers.length}
              </span>
        </div>
      `,
                            className: "custom-cluster",
                            iconSize: L.point(50, 50),
                          });
                        }}
                      >
                        {/* Markers for delivery pins */}
                        {deliveryPinLocation
                          .filter((marker) => marker["stop_code"] != null)
                          .map((coord, index) => (
                            <Marker key={`delivery-${index}`} position={[coord.latitude, coord.longitude]} icon={createCompletedPinMarker(index + 1)}>
                              <Popup>
                                <div style={{ minWidth: "250px", padding: "10px" }}>
                                  <p
                                    style={{
                                      margin: "4px 0",
                                      fontSize: "13px",
                                    }}
                                  >
                                    <strong>Trip:</strong> {coord.trip_id || "N/A"}
                                  </p>
                                  <p
                                    style={{
                                      margin: "4px 0",
                                      fontSize: "13px",
                                    }}
                                  >
                                    <strong>Stop:</strong> {coord.stop_code || "N/A"}
                                  </p>
                                  <p
                                    style={{
                                      margin: "4px 0",
                                      fontSize: "13px",
                                    }}
                                  >
                                    <strong>Status:</strong> {coord.status || "N/A"}
                                  </p>
                                </div>
                              </Popup>
                            </Marker>
                          ))}
                      </MarkerClusterGroup>
                      {/* Polylines */}
                      {polylinePlanned.map((poly, index) => (
                        <Polyline key={`${poly.id}`} positions={poly.positionList} color="#FDCA01" weight={5} />
                      ))}
                      {polylineHistory.map((poly, index) => (
                        <Polyline key={`${poly.id}`} positions={poly.positionList} color="#3469E7" weight={4} />
                      ))}

                      {/* Polylines */}
                      {/* <Polyline positions={route1} color="blue" weight={4} />
                         <Polyline positions={route2} color="red" weight={4} dashArray="5,10" /> */}
                    </MapContainer>
                  </div>
                </div>
              </div>

              <div style={{ width: 380 }}>
                <div className="bg-white rounded-4" style={{ height: "68vh", overflowY: "auto" }}>
                  {trip?.next_stop && (
                    <div className="rounded-4 p-3 mb-3" style={{ background: "#F0EBFF" }}>
                      <div className="bg-white rounded-3 p-2 d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center justify-content-start">
                          <div
                            className="d-flex align-items-center justify-content-center px-3"
                            style={{
                              width: "28px",
                              height: "28px",
                              borderRadius: "100px",
                              background: "#F5F5F5",
                            }}
                          >
                            <img src={stopIcon} alt="Stop Icon" />
                          </div>
                          <div className="time-text-value ms-2">#{trip?.next_stop?.code ?? ""}</div>
                        </div>

                        <div className="d-flex align-items-center justify-content-end">
                          <div
                            className="d-flex align-items-center justify-content-center rounded-2 px-2 fs-11 fw-500"
                            style={{
                              background: "#F0EBFF",
                              height: "26px",
                              color: "#7157C2",
                            }}
                          >
                            Next Stop
                          </div>
                          <div
                            onClick={() => {}}
                            className="ms-2 d-flex align-items-center justify-content-center"
                            style={{
                              width: "28px",
                              height: "28px",
                              borderRadius: "100px",
                              background: "#F6F6F6",
                            }}
                          >
                            <img src={receiverIcon} alt="Receiver Icon" />
                          </div>
                        </div>
                      </div>
                      <div className="w-100 d-flex align-items-center justify-content-between mt-3">
                        <div className="d-flex align-items-center gap-2" style={{ flex: 1 }}>
                          <div
                            style={{
                              width: "36px",
                              height: "36px",
                              borderRadius: 8,
                              background: "#F4F4F6",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              cursor: trip?.next_stop?.profile && trip?.next_stop?.profile !== "" ? "pointer" : "default",
                              overflow: "hidden",
                            }}
                            onClick={() => {
                              if (trip?.next_stop?.profile && trip?.next_stop?.profile !== "") {
                                setSelectedProfile(trip.next_stop.profile);
                                setShowProfilePopup(true);
                              }
                            }}
                          >
                            {trip?.next_stop?.profile && trip?.next_stop?.profile !== "" ? (
                              <img
                                src={trip.next_stop.profile}
                                alt="profile"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                }}
                              />
                            ) : (
                              trip?.next_stop?.customer?.charAt(0) ?? "C"
                            )}
                          </div>
                          <div>
                            <div className="trip-batch-driver break-word">{trip?.license_plate ?? ""}</div>
                            <div className="mt-1 trip-batch-vehicle">{trip?.next_stop?.ph_number ?? ""}</div>
                          </div>
                        </div>

                        <div className="d-flex gap-2" style={{ width: "86px" }}>
                          {/* <div
                          onClick={(e) => {
                            e.stopPropagation();
       
                          }}
                          className="d-flex align-items-center justify-content-center"
                          style={{
                            width: "36px",
                            height: "36px",
                            borderRadius: "100px",
                            background: "#F6F6F6",
                          }}
                        >
                          <img src={tripRouteIcon} alt="Trip Route Icon" />
                        </div> */}

                          {trip?.next_stop?.ph_number && (
                            <div
                              onClick={() => (window.location.href = `tel:${trip?.next_stop?.ph_number ?? ""}`)}
                              className="d-flex align-items-center justify-content-center"
                              style={{
                                width: "36px",
                                height: "36px",
                                borderRadius: "100px",
                                background: "#F6F6F6",
                              }}
                            >
                              <img src={receiverIcon} alt="Receiver Icon" />
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="mt-2 d-flex align-items-center justify-content-start">
                        <div
                          className="d-flex align-items-center justify-content-center px-3"
                          style={{
                            width: "36px",
                            height: "36px",
                            borderRadius: "100px",
                            background: "#F6F6F6",
                          }}
                        >
                          <img src={locationIcon} alt="Location Icon" />
                        </div>
                        <div className="location-address ms-2">{trip?.next_stop?.address ?? ""}</div>
                      </div>
                    </div>
                  )}
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="d-flex gap-2 align-items-center">
                      <button className={`btn btn-sm ${stopsFilter === "All" ? "selected-btn selected-stop-btn" : "deselect-btn deselect-stop-btn"}`} onClick={() => setStopsFilter("All")}>
                        All
                      </button>
                      <button className={`btn btn-sm ${stopsFilter === "true" ? "selected-btn selected-stop-btn" : "deselect-btn deselect-stop-btn"}`} onClick={() => setStopsFilter("true")}>
                        Completed
                      </button>
                      <button className={`btn btn-sm ${stopsFilter === "false" ? "selected-btn selected-stop-btn" : "deselect-btn deselect-stop-btn"}`} onClick={() => setStopsFilter("false")}>
                        Pending
                      </button>
                    </div>
                  </div>

                  <div className="mb-3">
                    <input className="form-control form-control-sm" placeholder="Search stops" value={query} onChange={(e) => setQuery(e.target.value)} />
                  </div>

                  {stopList.map((stop, index) => (
                    <div key={`stop_${index}`} className="mb-3">
                      <div className="rounded-4 p-3 mb-3" style={{ background: "#F0EBFF" }}>
                        <div className="bg-white rounded-3 p-2 d-flex align-items-center justify-content-between">
                          <div className="d-flex align-items-center justify-content-start">
                            <div
                              className="d-flex align-items-center justify-content-center px-3"
                              style={{
                                width: "28px",
                                height: "28px",
                                borderRadius: "100px",
                                background: "#F5F5F5",
                              }}
                            >
                              <img src={stopIcon} alt="Stop Icon" />
                            </div>
                            <div className="time-text-value ms-2">#{stop.stop_code ?? "---"}</div>
                          </div>

                          <div className="d-flex align-items-center justify-content-end">
                            {stop.status === true && (
                              <div
                                className="d-flex align-items-center justify-content-center rounded-2 px-2 fs-11 fw-500"
                                style={{
                                  background: "#D2FFE4",
                                  height: "26px",
                                  color: "#2C8C53",
                                }}
                              >
                                Completed
                              </div>
                            )}

                            {stop.status === false && (
                              <div
                                className="d-flex align-items-center justify-content-center rounded-2 px-2 fs-11 fw-500"
                                style={{
                                  background: "#FFF9E3",
                                  height: "26px",
                                  color: "#FFC05D",
                                }}
                              >
                                Pending
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="w-100 d-flex align-items-center justify-content-between mt-3">
                          <div className="d-flex align-items-center gap-2" style={{ flex: 1 }}>
                            <div
                              style={{
                                width: "36px",
                                height: "36px",
                                borderRadius: 8,
                                background: "#F4F4F6",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: stop?.profile && stop?.profile !== "" ? "pointer" : "default",
                                overflow: "hidden",
                              }}
                              onClick={() => {
                                if (stop?.profile && stop?.profile !== "") {
                                  setSelectedProfile(stop.profile);
                                  setShowProfilePopup(true);
                                }
                              }}
                            >
                              {stop?.profile && stop?.profile !== "" ? (
                                <img
                                  src={stop.profile}
                                  alt="profile"
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                  }}
                                />
                              ) : (
                                stop?.customer?.charAt(0) ?? "C"
                              )}
                            </div>
                            <div>
                              <div className="trip-batch-driver break-word">{stop.customer ?? ""}</div>
                              <div className="mt-1 trip-batch-vehicle">{stop.ph_number ?? ""}</div>
                            </div>
                          </div>

                          <div className="d-flex gap-2" style={{ width: "86px" }}>
                            {/* <div
                              onClick={(e) => {
                                e.stopPropagation();
                          
                              }}
                              className="d-flex align-items-center justify-content-center"
                              style={{
                                width: "36px",
                                height: "36px",
                                borderRadius: "100px",
                                background: "#F6F6F6",
                              }}
                            >
                              <img src={tripRouteIcon} alt="Trip Route Icon" />
                            </div> */}

                            {trip?.driverDetails?.length > 0 && (
                              <div
                                onClick={() => (window.location.href = `tel:${stop.ph_number ?? ""}`)}
                                className="d-flex align-items-center justify-content-center"
                                style={{
                                  width: "36px",
                                  height: "36px",
                                  borderRadius: "100px",
                                  background: "#F6F6F6",
                                }}
                              >
                                <img src={receiverIcon} alt="Receiver Icon" />
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="mt-2 d-flex align-items-center justify-content-start">
                          <div
                            className="d-flex align-items-center justify-content-center px-3"
                            style={{
                              width: "36px",
                              height: "36px",
                              borderRadius: "100px",
                              background: "#F6F6F6",
                            }}
                          >
                            <img src={locationIcon} alt="Location Icon" />
                          </div>
                          <div className="location-address ms-2">{stop.address ?? ""}</div>
                        </div>
                        <div className="mt-2 bg-white rounded-3 d-flex align-items-center justify-content-between">
                          <div className="ms-2 d-flex flex-column align-items-start py-1">
                            <div className="fs-11 fw-400 text-gray">Planned Delivery Time </div>
                            <div className="fs-11 fw-500 textcolor">{stop.planned_time ?? ""}</div>
                          </div>

                          <div className="px-2 d-flex flex-column align-items-start  py-1" style={{ border: "1px solid #EBEBEB" }}>
                            <div className="fs-11 fw-400 text-gray">Actual Delivery Time </div>
                            <div className="fs-11 fw-500 textcolor">{stop.actual_time ?? ""}</div>
                          </div>
                          <div className="me-2 d-flex flex-column align-items-start py-1">
                            <div className="fs-11 fw-400 text-gray">Seq. </div>
                            <div className="fs-11 fw-500 textcolor">{stop.seq ?? ""} </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer position="top-end" className="p-3" style={{ zIndex: 9999 }}>
        <Toast onClose={() => setToast({ ...toast, show: false })} show={toast.show} delay={3000} autohide bg={toast.variant}>
          <Toast.Body className="text-white">{toast.message}</Toast.Body>
        </Toast>
      </ToastContainer>

      {/* Profile Image Modal */}
      <ProfileImageModal show={showProfilePopup} onClose={() => setShowProfilePopup(false)} imageUrl={selectedProfile} />
    </div>
  );
};
